var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      staticClass: "d-none d-md-block sidebar blinki-sidebar",
      class: { "mini-menu pr-2": !_vm.full, "col-md-2": _vm.full },
    },
    [
      _vm.full
        ? _c("div", { staticClass: "sidebar-sticky" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "nav flex-column" },
              [
                _vm._l(_vm.menu, function (elem, index) {
                  return [
                    !elem.hidden
                      ? _c("li", { key: index }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "canAccess",
                                  rawName: "v-canAccess",
                                  value: _vm.canAccess(elem),
                                  expression: "canAccess(elem)",
                                },
                              ],
                              staticClass: "nav-item",
                            },
                            [
                              _c(
                                "nuxt-link",
                                {
                                  staticClass: "nav-link",
                                  attrs: {
                                    to: elem.path,
                                    exact: "",
                                    href: "#",
                                  },
                                },
                                [_c("span", [_vm._v(_vm._s(elem.title))])]
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
          ])
        : _c("div", { staticClass: "sidebar-sticky over-auto" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "nav flex-column" },
              [
                _vm._l(_vm.menu, function (elem, index) {
                  return [
                    !elem.hidden
                      ? _c("li", { key: index }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "canAccess",
                                  rawName: "v-canAccess",
                                  value: _vm.canAccess(elem),
                                  expression: "canAccess(elem)",
                                },
                              ],
                              staticClass: "nav-item absolu",
                              on: {
                                mouseover: function ($event) {
                                  return _vm.mouseOver(elem)
                                },
                                mouseleave: _vm.mouseLeave,
                              },
                            },
                            [
                              elem.path === "/commandes"
                                ? [
                                    _c(
                                      "nuxt-link",
                                      {
                                        staticClass:
                                          "nav-link mini flex f-j-center f-center custom-links",
                                        attrs: {
                                          to: elem.path,
                                          exact: "",
                                          href: "#",
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticStyle: {
                                              "enable-background":
                                                "new 0 0 403.12 403.12",
                                            },
                                            attrs: {
                                              id: "Capa_1",
                                              "xmlns:xlink":
                                                "http://www.w3.org/1999/xlink",
                                              x: "0px",
                                              y: "0px",
                                              viewBox: "0 0 403.12 403.12",
                                              "xml:space": "preserve",
                                            },
                                          },
                                          [
                                            _c("g", [
                                              _c("g", [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M211.6,183.351l-155.92-64.88c-4.087-1.679-8.761,0.273-10.44,4.36c-0.391,0.952-0.595,1.971-0.6,3v56.88H74.4\n\t\t\tc4.418,0,8,3.582,8,8s-3.582,8-8,8H33.44c-4.418,0.006-7.995,3.593-7.989,8.011c0.006,4.41,3.579,7.983,7.989,7.989h11.2v6.96H128\n\t\t\tc4.418,0,8,3.582,8,8s-3.582,8-8,8H8c-4.418,0-8,3.582-8,8s3.582,8,8,8h36.8v6.96h44.64c4.418,0,8,3.582,8,8s-3.582,8-8,8H22\n\t\t\tc-4.418,0-8,3.582-8,8s3.582,8,8,8h22.64v12.96c-0.281,3.42,1.65,6.639,4.8,8l156,64.56c4.087,1.679,8.761-0.273,10.44-4.36\n\t\t\tc0.391-0.952,0.595-1.971,0.6-3v-180.08C216.477,187.501,214.556,184.603,211.6,183.351z",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("g", [
                                              _c("g", [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M399.52,119.191c-2.228-1.483-5.051-1.753-7.52-0.72l-155.84,64.88c-2.987,1.227-4.944,4.13-4.96,7.36v180.08\n\t\t\tc0.022,4.418,3.622,7.982,8.04,7.96c1.029-0.005,2.048-0.209,3-0.6l155.92-64.56c2.987-1.227,4.944-4.13,4.96-7.36v-180.4\n\t\t\tC403.106,123.155,401.755,120.663,399.52,119.191z M269.52,341.511c-0.048,3.233-0.989,6.389-2.72,9.12\n\t\t\tc-2.864,4.537-7.918,7.216-13.28,7.04c-0.985,0.082-1.975,0.082-2.96,0c-8.972-1.989-14.634-10.874-12.645-19.846\n\t\t\tc1.125-5.078,4.561-9.338,9.285-11.514c2.01-0.803,4.156-1.211,6.32-1.2c8.837-0.003,16.002,7.158,16.005,15.995\n\t\t\tC269.525,341.241,269.523,341.376,269.52,341.511z M304.08,335.111L304.08,335.111c-2.064,6.319-7.993,10.564-14.64,10.48\n\t\t\tc-2.224,0.008-4.427-0.427-6.48-1.28c-6.094-2.688-9.886-8.869-9.52-15.52c0-8.837,7.163-16,16-16s16,7.163,16,16\n\t\t\tC305.37,330.962,304.909,333.103,304.08,335.111z",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("g", [
                                              _c("g", [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M382.72,87.751l-60.4-24l-20.72,8.88l-131.44,56.4l-20.48,8.56l71.12,29.6c1.971,0.822,4.189,0.822,6.16,0l155.92-64.88\n\t\t\tc2.903-1.229,4.814-4.048,4.88-7.2C387.731,91.862,385.739,88.953,382.72,87.751z",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("g", [
                                              _c("g", [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M226.88,24.951c-1.924-0.778-4.076-0.778-6,0l-155.92,62.8c-4.087,1.679-6.039,6.353-4.36,10.44\n\t\t\tc0.812,1.978,2.383,3.548,4.36,4.36h-0.08l64.56,27.04l20.48-8.8l131.2-56.56l20.72-8.96L226.88,24.951z",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("g", [
                                              _c("g", [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M253.93,332.801c-0.137-0.007-0.273-0.01-0.41-0.01c-4.634-0.221-8.57,3.357-8.79,7.99c-0.221,4.634,3.357,8.57,7.99,8.79\n\t\t\tc4.634,0.221,8.57-3.357,8.79-7.99c0.006-0.13,0.009-0.26,0.01-0.391C261.741,336.778,258.343,333.022,253.93,332.801z",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("g", [
                                              _c("g", [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M289.85,320.401c-0.137-0.007-0.273-0.01-0.41-0.01c-4.634-0.221-8.57,3.357-8.79,7.99c-0.221,4.634,3.357,8.57,7.99,8.79\n\t\t\tc4.634,0.221,8.57-3.357,8.79-7.99c0.006-0.13,0.009-0.26,0.01-0.391C297.661,324.378,294.263,320.622,289.85,320.401z",
                                                  },
                                                }),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                : elem.path === "/retours"
                                ? [
                                    _c(
                                      "nuxt-link",
                                      {
                                        staticClass:
                                          "nav-link mini flex f-j-center f-center custom-links",
                                        attrs: {
                                          to: elem.path,
                                          exact: "",
                                          href: "#",
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticStyle: {
                                              "enable-background":
                                                "new 0 0 489.394 489.394",
                                            },
                                            attrs: {
                                              id: "Capa_1",
                                              "xmlns:xlink":
                                                "http://www.w3.org/1999/xlink",
                                              x: "0px",
                                              y: "0px",
                                              width: "489.394px",
                                              height: "489.394px",
                                              viewBox: "0 0 489.394 489.394",
                                              "xml:space": "preserve",
                                            },
                                          },
                                          [
                                            _c("g", [
                                              _c("path", {
                                                attrs: {
                                                  d: "M375.789,92.867H166.864l17.507-42.795c3.724-9.132,1-19.574-6.691-25.744c-7.701-6.166-18.538-6.508-26.639-0.879\n\t\tL9.574,121.71c-6.197,4.304-9.795,11.457-9.563,18.995c0.231,7.533,4.261,14.446,10.71,18.359l147.925,89.823\n\t\tc8.417,5.108,19.18,4.093,26.481-2.499c7.312-6.591,9.427-17.312,5.219-26.202l-19.443-41.132h204.886\n\t\tc15.119,0,27.418,12.536,27.418,27.654v149.852c0,15.118-12.299,27.19-27.418,27.19h-226.74c-20.226,0-36.623,16.396-36.623,36.622\n\t\tv12.942c0,20.228,16.397,36.624,36.623,36.624h226.74c62.642,0,113.604-50.732,113.604-113.379V206.709\n\t\tC489.395,144.062,438.431,92.867,375.789,92.867z",
                                                },
                                              }),
                                            ]),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                : elem.path === "/products"
                                ? [
                                    _c(
                                      "nuxt-link",
                                      {
                                        staticClass:
                                          "nav-link mini flex f-j-center f-center custom-links",
                                        attrs: {
                                          to: elem.path,
                                          exact: "",
                                          href: "#",
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              id: "Capa_1",
                                              height: "512pt",
                                              viewBox: "-33 0 512 512.002",
                                              width: "512pt",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "m136.289062 271h180c8.292969 0 15-6.710938 15-15v-181c0-8.289062-6.707031-15-15-15h-45v-15c0-24.8125-20.1875-45-45-45s-45 20.1875-45 45v15h-45c-8.289062 0-15 6.710938-15 15v181c0 8.289062 6.710938 15 15 15zm75-226c0-8.277344 6.738282-15 15-15 8.261719 0 15 6.722656 15 15v15h-30zm0 0",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              attrs: {
                                                d: "m444.816406 248.234375c-2.695312-4.480469-7.589844-7.234375-12.832031-7.234375-26.429687 0-50.675781 14.667969-62.945313 38.078125l-46.011718 87.8125c-7.820313 14.882813-23.085938 24.109375-39.871094 24.109375h-101.867188c-8.289062 0-15-6.710938-15-15s6.710938-15 15-15h101.863282c5.597656 0 10.695312-3.074219 13.304687-8.042969 2.597657-4.960937 10.445313-19.941406 17.191407-32.816406 2.125-4.054687 1.976562-8.925781-.394532-12.84375-2.375-3.914063-6.621094-6.296875-11.199218-6.296875h-155.921876c-20.039062 0-38.847656 7.808594-53.027343 21.972656l-88.710938 88.710938c-5.859375 5.859375-5.859375 15.351562 0 21.210937l75 74.710938c2.929688 2.929687 6.769531 4.398437 10.605469 4.398437s7.675781-1.46875 10.605469-4.398437l56.894531-56.605469h125.652344c39.171875 0 74.824218-21.5625 93.019531-56.265625l69.082031-131.761719c2.460938-4.644531 2.285156-10.238281-.4375-14.738281zm0 0",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                : elem.path === "/products-drafts"
                                ? [
                                    _c(
                                      "nuxt-link",
                                      {
                                        staticClass:
                                          "nav-link mini flex f-j-center f-center custom-links",
                                        attrs: {
                                          to: elem.path,
                                          exact: "",
                                          href: "#",
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticStyle: {
                                              "enable-background":
                                                "new 0 0 360.984 360.984",
                                            },
                                            attrs: {
                                              id: "Capa_1",
                                              viewBox: "0 0 360.984 360.984",
                                              "xml:space": "preserve",
                                            },
                                          },
                                          [
                                            _c("g", [
                                              _c("polygon", {
                                                attrs: {
                                                  points:
                                                    "217.646,183.577 229.407,183.577 223.49,170.812 \t",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  d: "M171.329,164.241h-6.927v13.08l9.718,0.004c1.798-0.489,5.669-2.077,5.669-6.674\n\t\tC179.789,168.898,179.789,164.241,171.329,164.241z",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  d: "M123.251,163.544h-12.029v33.404h12.029c9.503,0,17.234-7.48,17.234-16.673\n\t\tC140.485,171.05,132.754,163.544,123.251,163.544z",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  d: "M345.984,91.765H58.523c-5.308,0-10.22,2.805-12.917,7.375L2.083,172.867c-2.777,4.704-2.777,10.546,0,15.25l43.524,73.728\n\t\tc2.697,4.57,7.609,7.375,12.917,7.375h287.461c8.284,0,15-6.716,15-15V106.765C360.984,98.48,354.269,91.765,345.984,91.765z\n\t\t M123.251,207.407h-17.259c-2.889,0-5.229-2.341-5.229-5.229v-43.863c0-2.889,2.341-5.229,5.229-5.229h17.259\n\t\tc15.27,0,27.692,12.197,27.692,27.19C150.943,195.236,138.521,207.407,123.251,207.407z M192.486,206.677\n\t\tc-2.326,1.709-5.6,1.212-7.313-1.114l-13.078-17.779l-7.693-0.003v15.095c0,2.889-2.342,5.23-5.229,5.23\n\t\tc-2.889,0-5.23-2.341-5.23-5.23v-43.863c0-2.889,2.341-5.23,5.23-5.23h12.156c11.67,0,18.919,6.464,18.919,16.869\n\t\tc0,5.798-2.813,10.876-7.435,14.052l10.787,14.662C195.311,201.691,194.813,204.965,192.486,206.677z M245.992,206.922\n\t\tc-2.62,1.214-5.729,0.076-6.943-2.545l-4.794-10.341h-21.396l-4.725,10.318c-0.879,1.921-2.775,3.054-4.758,3.054\n\t\tc-0.729,0-1.469-0.152-2.174-0.476c-2.626-1.202-3.78-4.306-2.578-6.932l20.082-43.863c0.85-1.856,2.701-3.048,4.742-3.053h0.013\n\t\tc2.036,0,3.888,1.182,4.744,3.03l20.332,43.863C249.752,202.599,248.612,205.708,245.992,206.922z M283.63,163.339h-20.314v11.88\n\t\th16.249c2.889,0,5.229,2.341,5.229,5.23c0,2.889-2.341,5.229-5.229,5.229h-16.249v16.869c0,2.889-2.342,5.229-5.229,5.229\n\t\tc-2.889,0-5.23-2.341-5.23-5.229v-44.438c0-2.889,2.341-5.23,5.23-5.23h25.543c2.889,0,5.229,2.341,5.229,5.23\n\t\tS286.519,163.339,283.63,163.339z M324.992,163.56h-9.17v37.377c0,2.889-2.341,5.229-5.229,5.229s-5.229-2.341-5.229-5.229V163.56\n\t\th-7.913c-2.89,0-5.229-2.341-5.229-5.229c0-2.889,2.34-5.23,5.229-5.23h13.143h14.399c2.889,0,5.229,2.341,5.229,5.23\n\t\tC330.222,161.219,327.881,163.56,324.992,163.56z",
                                                },
                                              }),
                                            ]),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                : elem.path === "/salons"
                                ? [
                                    _c(
                                      "nuxt-link",
                                      {
                                        staticClass:
                                          "nav-link mini flex f-j-center f-center custom-links",
                                        attrs: {
                                          to: elem.path,
                                          exact: "",
                                          href: "#",
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              id: "Capa_1",
                                              height: "512",
                                              viewBox: "0 0 24 24",
                                              width: "512",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "m19 18.01h-14c-.552 0-1-.448-1-1s.448-1 1-1h14c.552 0 1 .448 1 1s-.448 1-1 1z",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              attrs: {
                                                d: "m19 12h-14c-.552 0-1-.448-1-1s.448-1 1-1h14c.552 0 1 .448 1 1s-.448 1-1 1z",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              attrs: {
                                                d: "m10 13c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              attrs: {
                                                d: "m15 19c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              attrs: {
                                                d: "m21 1h-18c-1.654 0-3 1.346-3 3v16c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3v-16c0-1.654-1.346-3-3-3zm0 20h-18c-.551 0-1-.448-1-1v-14h20v14c0 .552-.449 1-1 1z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                : elem.path === "/messagerie"
                                ? [
                                    _c(
                                      "nuxt-link",
                                      {
                                        staticClass:
                                          "nav-link mini flex f-j-center f-center custom-links",
                                        attrs: {
                                          to: elem.path,
                                          exact: "",
                                          href: "#",
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticStyle: {
                                              "enable-background":
                                                "new 0 0 30.743 30.744",
                                            },
                                            attrs: {
                                              id: "Capa_1",
                                              width: "30.743px",
                                              height: "30.744px",
                                              viewBox: "0 0 30.743 30.744",
                                              "xml:space": "preserve",
                                            },
                                          },
                                          [
                                            _c("g", [
                                              _c("path", {
                                                attrs: {
                                                  d: "M28.585,9.67h-0.842v9.255c0,1.441-0.839,2.744-2.521,2.744H8.743v0.44c0,1.274,1.449,2.56,2.937,2.56h12.599l4.82,2.834\n\t\tL28.4,24.669h0.185c1.487,0,2.158-1.283,2.158-2.56V11.867C30.743,10.593,30.072,9.67,28.585,9.67z",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  d: "M22.762,3.24H3.622C1.938,3.24,0,4.736,0,6.178v11.6c0,1.328,1.642,2.287,3.217,2.435l-1.025,3.891L8.76,20.24h14.002\n\t\tc1.684,0,3.238-1.021,3.238-2.462V8.393V6.178C26,4.736,24.445,3.24,22.762,3.24z M6.542,13.032c-0.955,0-1.729-0.774-1.729-1.729\n\t\ts0.774-1.729,1.729-1.729c0.954,0,1.729,0.774,1.729,1.729S7.496,13.032,6.542,13.032z M13,13.032\n\t\tc-0.955,0-1.729-0.774-1.729-1.729S12.045,9.574,13,9.574s1.729,0.774,1.729,1.729S13.955,13.032,13,13.032z M19.459,13.032\n\t\tc-0.955,0-1.73-0.774-1.73-1.729s0.775-1.729,1.73-1.729c0.953,0,1.729,0.774,1.729,1.729S20.412,13.032,19.459,13.032z",
                                                },
                                              }),
                                            ]),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                            _vm._v(" "),
                                            _c("g"),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                : [
                                    _c(
                                      "nuxt-link",
                                      {
                                        staticClass:
                                          "nav-link mini flex f-j-center f-center",
                                        attrs: {
                                          to: elem.path,
                                          exact: "",
                                          href: "#",
                                        },
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "menu-icon",
                                          class: "icon-" + elem.icon,
                                        }),
                                      ]
                                    ),
                                  ],
                              _vm._v(" "),
                              elem.title === _vm.tooltip
                                ? _c("div", { staticClass: "blinki-tooltip" }, [
                                    _vm._v(_vm._s(elem.title)),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
          ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "blinki-logo-container" }, [
      _c("div", { staticClass: "blinki-logo" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "blinki-logo-container" }, [
      _c("div", { staticClass: "blinki-logo" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }